import React from 'react'

const FAQs = () => {
    const faqs = [
        {
            id: 1,
            category: "Smart Formats",
            questions: [
                {
                    id: 1,
                    question: "What is a Smart Format?",
                    answer: "Smart Formats are physical items that unlock chart-eligible music and content on Serenade. They can be as collectible as a mini CD or cassette or as simple as a sticker placed on a concert poster. Each Smart Format contains 1 unique redemption link that is accessed when a fan taps the item on their phone, engaging an NFC chip hidden within.",
                    visible: false
                },
                {
                    id: 2,
                    question: "What items can be Smart Formats?",
                    answer: "Any item that can conceal an NFC chip can conceivably be a Smart Format. We’ve heard it all by now, from silicone droid keyrings to action figures with chips embedded in their heads. If you have an idea for a product that we haven’t listed, please get in touch and we can create a custom quote for you. That said, if you want your Smart Format to be chart eligible, we offer a list of pre-approved items here.",
                    visible: false
                },
                {
                    id: 3,
                    question: "Where are Smart Formats available?",
                    answer: "Smart Formats are available for purchase globally, but as they are shipped from London, UK, please be conscious of delivery timelines when coordinating your release.",
                    visible: false
                },
                {
                    id: 4,
                    question: "Are Smart Formats chart eligible?",
                    answer: "Smart Formats count towards the OCC Chart in the United Kingdom and Ireland; GfK in Germany, Austria, Belgium, and the Netherlands; and ARIA in Australia and New Zealand. We are not chart accredited in the US yet. Rules apply to each territory, see here for more information. Serenade is accountable for reporting all sales of Smart Formats, reporting a sale once a fan taps a Smart Format on their phone and redeems the digital product contained within.",
                    visible: false
                },
                {
                    id: 5,
                    question: "How much do Smart Formats cost?",
                    answer: "Check out our Shop Smart Formats page for pricing information.",
                    visible: false
                },
                {
                    id: 6,
                    question: "Can I make my own Smart Formats powered by Serenade’s technology?",
                    answer: "We work collaboratively with third party manufacturers and brokers that use our technology while building their own physical items. See our Digital License product page for more information.",
                    visible: false
                },
                {
                    id: 7,
                    question: "What are the most sustainable Smart Formats?",
                    answer: "We offer sustainable options for virtually every one of our products. Select the ‘No plastic’ option on each product page to see product variants that leverage cardboard, metal and sustainable materials like bamboo.",
                    visible: false
                },
                {
                    id: 8,
                    question: "What if my fans don’t have a smartphone or it isn’t NFC-enabled?",
                    answer: "All smart phones since 2015 have included NFC-reading functionality. That said, if you stumble across a fan with an older phone, suggest that they redeem their Smart Format with a friend’s device.",
                    visible: false
                },
                {
                    id: 9,
                    question: "Does Serenade custom design my Smart Formats?",
                    answer: "Once an order is placed, you will be asked to deliver artwork and other creative assets to Serenade to help design your perfect Smart Formats on the house. Like a vinyl, CD or cassette, the nuts and bolts of each Smart Format are fixed, but artists personalise their products with their own artwork, colours and fonts.",
                    visible: false
                },
                {
                    id: 10,
                    question: "What is the lead time from purchase to delivery?",
                    answer: "Smart Formats that require no custom design work like our stickers and clothing tags are posted in 1-3 days from purchase, meaning you can place an order and list your products for sale within the week. Custom products have lead times varying from 2-6 weeks. All items are posted from London UK to the world, so please bear this in mind when setting expectations.",
                    visible: false
                },
                {
                    id: 11,
                    question: "What items are your best sellers?",
                    answer: "Our best seller is undoubtedly our sticker as we can turn around an order overnight and help with last minute campaign pressures. Other than our stickers, mini CDs, cassettes and patches have been big hits with artists and fans.",
                    visible: false
                },
            ]
        },
        {
            id: 2,
            category: "Digital Content",
            questions: [
                {
                    id: 12,
                    question: "What is a Smart Format?",
                    answer: "Smart Formats are physical items that unlock chart-eligible music and content on Serenade. They can be as collectible as a mini CD or cassette or as simple as a sticker placed on a concert poster. Each Smart Format contains 1 unique redemption link that is accessed when a fan taps the item on their phone, engaging an NFC chip hidden within.",
                    visible: false
                },
                {
                    id: 13,
                    question: "What items can be Smart Formats?",
                    answer: "Any item that can conceal an NFC chip can conceivably be a Smart Format. We’ve heard it all by now, from silicone droid keyrings to action figures with chips embedded in their heads. If you have an idea for a product that we haven’t listed, please get in touch and we can create a custom quote for you. That said, if you want your Smart Format to be chart eligible, we offer a list of pre-approved items here.",
                    visible: false
                },
                {
                    id: 14,
                    question: "Where are Smart Formats available?",
                    answer: "Smart Formats are available for purchase globally, but as they are shipped from London, UK, please be conscious of delivery timelines when coordinating your release.",
                    visible: false
                },
                {
                    id: 15,
                    question: "Are Smart Formats chart eligible?",
                    answer: "Smart Formats count towards the OCC Chart in the United Kingdom and Ireland; GfK in Germany, Austria, Belgium, and the Netherlands; and ARIA in Australia and New Zealand. We are not chart accredited in the US yet. Rules apply to each territory, see here for more information. Serenade is accountable for reporting all sales of Smart Formats, reporting a sale once a fan taps a Smart Format on their phone and redeems the digital product contained within.",
                    visible: false
                },
                {
                    id: 16,
                    question: "How much do Smart Formats cost?",
                    answer: "Check out our Shop Smart Formats page for pricing information.",
                    visible: false
                },
                {
                    id: 17,
                    question: "Can I make my own Smart Formats powered by Serenade’s technology?",
                    answer: "We work collaboratively with third party manufacturers and brokers that use our technology while building their own physical items. See our Digital License product page for more information.",
                    visible: false
                },
                {
                    id: 18,
                    question: "What are the most sustainable Smart Formats?",
                    answer: "We offer sustainable options for virtually every one of our products. Select the ‘No plastic’ option on each product page to see product variants that leverage cardboard, metal and sustainable materials like bamboo.",
                    visible: false
                },
                {
                    id: 19,
                    question: "What if my fans don’t have a smartphone or it isn’t NFC-enabled?",
                    answer: "All smart phones since 2015 have included NFC-reading functionality. That said, if you stumble across a fan with an older phone, suggest that they redeem their Smart Format with a friend’s device.",
                    visible: false
                },
                {
                    id: 20,
                    question: "Does Serenade custom design my Smart Formats?",
                    answer: "Once an order is placed, you will be asked to deliver artwork and other creative assets to Serenade to help design your perfect Smart Formats on the house. Like a vinyl, CD or cassette, the nuts and bolts of each Smart Format are fixed, but artists personalise their products with their own artwork, colours and fonts.",
                    visible: false
                },
                {
                    id: 21,
                    question: "What is the lead time from purchase to delivery?",
                    answer: "Smart Formats that require no custom design work like our stickers and clothing tags are posted in 1-3 days from purchase, meaning you can place an order and list your products for sale within the week. Custom products have lead times varying from 2-6 weeks. All items are posted from London UK to the world, so please bear this in mind when setting expectations.",
                    visible: false
                },
                {
                    id: 22,
                    question: "What items are your best sellers?",
                    answer: "Our best seller is undoubtedly our sticker as we can turn around an order overnight and help with last minute campaign pressures. Other than our stickers, mini CDs, cassettes and patches have been big hits with artists and fans.",
                    visible: false
                },
            ]
        },
        {
            id: 3,
            category: "Selling & Marketing",
            questions: [
                {
                    id: 23,
                    question: "What is a Smart Format?",
                    answer: "Smart Formats are physical items that unlock chart-eligible music and content on Serenade. They can be as collectible as a mini CD or cassette or as simple as a sticker placed on a concert poster. Each Smart Format contains 1 unique redemption link that is accessed when a fan taps the item on their phone, engaging an NFC chip hidden within.",
                    visible: false
                },
                {
                    id: 24,
                    question: "What items can be Smart Formats?",
                    answer: "Any item that can conceal an NFC chip can conceivably be a Smart Format. We’ve heard it all by now, from silicone droid keyrings to action figures with chips embedded in their heads. If you have an idea for a product that we haven’t listed, please get in touch and we can create a custom quote for you. That said, if you want your Smart Format to be chart eligible, we offer a list of pre-approved items here.",
                    visible: false
                },
                {
                    id: 25,
                    question: "Where are Smart Formats available?",
                    answer: "Smart Formats are available for purchase globally, but as they are shipped from London, UK, please be conscious of delivery timelines when coordinating your release.",
                    visible: false
                },
                {
                    id: 26,
                    question: "Are Smart Formats chart eligible?",
                    answer: "Smart Formats count towards the OCC Chart in the United Kingdom and Ireland; GfK in Germany, Austria, Belgium, and the Netherlands; and ARIA in Australia and New Zealand. We are not chart accredited in the US yet. Rules apply to each territory, see here for more information. Serenade is accountable for reporting all sales of Smart Formats, reporting a sale once a fan taps a Smart Format on their phone and redeems the digital product contained within.",
                    visible: false
                },
                {
                    id: 27,
                    question: "How much do Smart Formats cost?",
                    answer: "Check out our Shop Smart Formats page for pricing information.",
                    visible: false
                },
                {
                    id: 28,
                    question: "Can I make my own Smart Formats powered by Serenade’s technology?",
                    answer: "We work collaboratively with third party manufacturers and brokers that use our technology while building their own physical items. See our Digital License product page for more information.",
                    visible: false
                },
                {
                    id: 29,
                    question: "What are the most sustainable Smart Formats?",
                    answer: "We offer sustainable options for virtually every one of our products. Select the ‘No plastic’ option on each product page to see product variants that leverage cardboard, metal and sustainable materials like bamboo.",
                    visible: false
                },
                {
                    id: 30,
                    question: "What if my fans don’t have a smartphone or it isn’t NFC-enabled?",
                    answer: "All smart phones since 2015 have included NFC-reading functionality. That said, if you stumble across a fan with an older phone, suggest that they redeem their Smart Format with a friend’s device.",
                    visible: false
                },
                {
                    id: 31,
                    question: "Does Serenade custom design my Smart Formats?",
                    answer: "Once an order is placed, you will be asked to deliver artwork and other creative assets to Serenade to help design your perfect Smart Formats on the house. Like a vinyl, CD or cassette, the nuts and bolts of each Smart Format are fixed, but artists personalise their products with their own artwork, colours and fonts.",
                    visible: false
                },
                {
                    id: 32,
                    question: "What is the lead time from purchase to delivery?",
                    answer: "Smart Formats that require no custom design work like our stickers and clothing tags are posted in 1-3 days from purchase, meaning you can place an order and list your products for sale within the week. Custom products have lead times varying from 2-6 weeks. All items are posted from London UK to the world, so please bear this in mind when setting expectations.",
                    visible: false
                },
                {
                    id: 33,
                    question: "What items are your best sellers?",
                    answer: "Our best seller is undoubtedly our sticker as we can turn around an order overnight and help with last minute campaign pressures. Other than our stickers, mini CDs, cassettes and patches have been big hits with artists and fans.",
                    visible: false
                },
            ]
        },
        {
            id: 4,
            category: "Serenade Support",
            questions: [
                {
                    id: 34,
                    question: "What is a Smart Format?",
                    answer: "Smart Formats are physical items that unlock chart-eligible music and content on Serenade. They can be as collectible as a mini CD or cassette or as simple as a sticker placed on a concert poster. Each Smart Format contains 1 unique redemption link that is accessed when a fan taps the item on their phone, engaging an NFC chip hidden within.",
                    visible: false
                },
                {
                    id: 35,
                    question: "What items can be Smart Formats?",
                    answer: "Any item that can conceal an NFC chip can conceivably be a Smart Format. We’ve heard it all by now, from silicone droid keyrings to action figures with chips embedded in their heads. If you have an idea for a product that we haven’t listed, please get in touch and we can create a custom quote for you. That said, if you want your Smart Format to be chart eligible, we offer a list of pre-approved items here.",
                    visible: false
                },
                {
                    id: 36,
                    question: "Where are Smart Formats available?",
                    answer: "Smart Formats are available for purchase globally, but as they are shipped from London, UK, please be conscious of delivery timelines when coordinating your release.",
                    visible: false
                },
                {
                    id: 37,
                    question: "Are Smart Formats chart eligible?",
                    answer: "Smart Formats count towards the OCC Chart in the United Kingdom and Ireland; GfK in Germany, Austria, Belgium, and the Netherlands; and ARIA in Australia and New Zealand. We are not chart accredited in the US yet. Rules apply to each territory, see here for more information. Serenade is accountable for reporting all sales of Smart Formats, reporting a sale once a fan taps a Smart Format on their phone and redeems the digital product contained within.",
                    visible: false
                },
                {
                    id: 38,
                    question: "How much do Smart Formats cost?",
                    answer: "Check out our Shop Smart Formats page for pricing information.",
                    visible: false
                },
                {
                    id: 39,
                    question: "Can I make my own Smart Formats powered by Serenade’s technology?",
                    answer: "We work collaboratively with third party manufacturers and brokers that use our technology while building their own physical items. See our Digital License product page for more information.",
                    visible: false
                },
                {
                    id: 40,
                    question: "What are the most sustainable Smart Formats?",
                    answer: "We offer sustainable options for virtually every one of our products. Select the ‘No plastic’ option on each product page to see product variants that leverage cardboard, metal and sustainable materials like bamboo.",
                    visible: false
                },
                {
                    id: 41,
                    question: "What if my fans don’t have a smartphone or it isn’t NFC-enabled?",
                    answer: "All smart phones since 2015 have included NFC-reading functionality. That said, if you stumble across a fan with an older phone, suggest that they redeem their Smart Format with a friend’s device.",
                    visible: false
                },
                {
                    id: 42,
                    question: "Does Serenade custom design my Smart Formats?",
                    answer: "Once an order is placed, you will be asked to deliver artwork and other creative assets to Serenade to help design your perfect Smart Formats on the house. Like a vinyl, CD or cassette, the nuts and bolts of each Smart Format are fixed, but artists personalise their products with their own artwork, colours and fonts.",
                    visible: false
                },
                {
                    id: 43,
                    question: "What is the lead time from purchase to delivery?",
                    answer: "Smart Formats that require no custom design work like our stickers and clothing tags are posted in 1-3 days from purchase, meaning you can place an order and list your products for sale within the week. Custom products have lead times varying from 2-6 weeks. All items are posted from London UK to the world, so please bear this in mind when setting expectations.",
                    visible: false
                },
                {
                    id: 44,
                    question: "What items are your best sellers?",
                    answer: "Our best seller is undoubtedly our sticker as we can turn around an order overnight and help with last minute campaign pressures. Other than our stickers, mini CDs, cassettes and patches have been big hits with artists and fans.",
                    visible: false
                },
            ]
        },
    ]

    const [currentFaqs, setCurrentFaqs] = React.useState(faqs)

    const handleFaqs = (id) => {
        setCurrentFaqs(currentFaqs.map(faqCategory => {
            return {
                ...faqCategory,
                questions: faqCategory.questions.map(question => {
                    if (question.id === id) {
                        return {
                            ...question,
                            visible: !question.visible
                        }
                    }
                    return question
                })
            }
        }))
    }

    console.log(currentFaqs)
    return (
        <div className='faqs py-[50px]'>
            <div className="container mx-auto">
                {/* breadcrumb */}
                <div className="breadcrumb rounded-xl faq-bradcrumb relative py-[60px] px-[50px]">
                    <h1 className="text-center text-white text-[40px] lg:text-[60px] font-bold">
                        Frequently Asked Questions
                    </h1>
                </div>
                {/* breadcrumb */}


                {/* faqs */}
                <div className="flex justify-between items-start lg:py-[50px] pb-[50px]">
                    <div className="left lg:block hidden w-[20%] sticky top-[120px]">
                        <ul className='faq-categories'>
                            {
                                faqs.map(faq => (
                                    <li key={faq.id} className='mb-5'>
                                        <a href={`#${faq.category}`} className='text-xl font-normal'>
                                            {faq.category}
                                        </a>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>

                    <div className="right w-full lg:w-[75%]">
                        {
                            currentFaqs.map(faq => (
                                <div key={faq.id} id={faq.category} className='faq-category'>
                                    <h2 className='text-[30px] lg:text-[40px] font-bold mt-20 lg:mt-0 mb-5'>
                                        {faq.category}
                                    </h2>
                                    {
                                        faq.questions.map(question => (
                                            <div key={question.question} className='faq mb-5' onClick={() => handleFaqs(question.id)}>
                                                <div className="question font-semibold text-lg flex justify-between items-center cursor-pointer">
                                                    <span>{question.question}</span>
                                                    <span className='text-[#172B85] text-xl'>{question.visible ? '-' : '+'}</span>
                                                </div>
                                                {question.visible && (
                                                    <div className="answer mt-5">
                                                        <p className='text-lg'>
                                                            {question.answer}
                                                        </p>
                                                    </div>
                                                )}
                                            </div>
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </div>
                </div>
                {/* faqs */}
            </div>
        </div>
    )
}

export default FAQs